import Lazyload from 'lazyload';
import videojs from 'video.js';
import 'video.js/dist/video-js.min.css';
import Swiper from 'swiper';
import { Autoplay, Pagination, FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import throttle from 'lodash/throttle';

import {
  fetchTopicContent,
  fetchAddReadCountByLog,
  fetchContentDetail,
  fetchGroupJson,
  fetchSiteJson,
  fetchTopicChannel,
  fetchTopicJson,
  fetchTopicChannelContent,
} from '../apis/api';

import '../scss/topicDetail.scss';
import initNewsTemplate from './newsTemplate';
import {
  browerVersion,
  getBrowerAppId,
  getSingleValueFromInput,
  getUrlQuery,
  isHideDownloadGuide,
} from './utils';
import initWxSdk from './wxSdk';
import YouMeng from './YouMeng';
import NanFang from './NanFang';

const contentLoadingImg = require('../assets/images/content-loading.png');
const topicMoreRightImg = require('../assets/images/topic-more-right.png');

const topicId = getSingleValueFromInput('newsId');

const version = browerVersion();
const staticType = Number(getSingleValueFromInput('staticType'));
const siteId = getSingleValueFromInput('siteId');

Swiper.use([Autoplay, Pagination, FreeMode]);

/**
 * 初始化sitejson
 */
const initSiteJson = () => {
  if (!version.myApp) {
    fetchSiteJson().then((res: Site.SiteJson) => {
      if (isHideDownloadGuide()) {
        return;
      }
      const headerGuideBox = $('#header-guide-box');
      if (!headerGuideBox || !res.name) {
        return;
      }
      // 设置下载链接
      headerGuideBox
        .find('a[name="download-link"]')
        .attr('data-href', res.downloadUrl)
        .attr('alt', res.name);
      // 设置引导图片
      headerGuideBox
        .find('img[name=guide-image]')
        .attr('src', res.guidePic)
        .attr('alt', res.name);
      headerGuideBox.find('img[name=guide-image]').on('load', (evt) => {
        const { clientWidth } = document.body;
        let imageHeight = '';
        let imageWidth = '';
        const { naturalHeight, naturalWidth } =
          evt.currentTarget as HTMLImageElement;
        if (clientWidth > 650) {
          imageWidth = '650px';
          imageHeight = `${(650 / naturalWidth) * naturalHeight}px`;
        } else {
          imageWidth = `${clientWidth}px`;
          imageHeight = `${(clientWidth / naturalWidth) * naturalHeight}px`;
        }
        $(evt.currentTarget).css({
          height: imageHeight,
          width: imageWidth,
        });
        initWxSdk({
          launchAppBtn: [
            {
              attr: 'id',
              value: 'header-guide-box',
            },
          ],
        });
        if (version.mobile) {
          $('#topic-group-title-swiper').css(
            'top',
            `${parseInt(imageHeight, 10) - 5}px`,
          );
        }
      });
      // 点击关闭按钮的事件
      headerGuideBox.find('img[name="close-guide"]').each((index, el) => {
        $(el).on('click', (evt) => {
          evt.preventDefault();
          evt.stopPropagation();
          headerGuideBox.hide();
          $('#topic-group-title-swiper').css('top', 0);
        });
      });
    });
  }
};

/**
 * 增加阅读量
 */
const addReadCount = () => {
  const newsId = getSingleValueFromInput('newsId');
  const contentType = getSingleValueFromInput('contentType');
  if (newsId && contentType && siteId) {
    fetchAddReadCountByLog(newsId, Number(contentType), siteId);
  }
};

/**
 * 简介的展开、收起
 */
const initDescriptionExpendClose = () => {
  $('.topic-description-expend-close').on('click', () => {
    if ($('.topic-description-text').hasClass('ellipsis')) {
      $('.topic-description-text').removeClass('ellipsis');
      $('.topic-description-expend-close').text('关闭');
    } else {
      $('.topic-description-text').addClass('ellipsis');
      $('.topic-description-expend-close').text('展开');
    }
  });
};

/**
 * 添加稿件内容到列表
 * @param list
 * @param node
 */
const addNewsToList = (
  list: RMT.News[],
  node: HTMLElement | JQuery<HTMLElement>,
) => {
  list.forEach((item) => {
    $(node).append(initNewsTemplate(item.data));
  });
  const images = $(node).find('.t-news-image');
  const newImages = images.filter(
    (index, el) => $(el).attr('src') !== $(el).attr('data-src'),
  );
  // eslint-disable-next-line no-new
  new Lazyload(newImages);
  const tVideos = $('.t-news-video');
  if (tVideos && tVideos.length) {
    tVideos.each((index, el) => {
      const videoEl = el as HTMLVideoElement;
      if (!videoEl.className.includes('vjs')) {
        const posterUrl =
          videoEl.getAttribute('poster') || process.env.DEFAULT_IMAGE_16_9;
        videoEl.style.backgroundImage = `url(${posterUrl})`;
        videoEl.style.backgroundSize = 'cover';
        videoEl.style.backgroundPosition = 'center';
        videoEl.style.backgroundRepeat = 'no-repeat';
        videoEl.style.backgroundBlendMode = 'normal';

        videojs(el, {
          aspectRatio: '16:9',
          controls: true,
          playbackRates: [0.75, 1, 1.25, 1.5, 2],
          poster: posterUrl,
        });
      }
    });
  }
};

let hasNext = false;
let isHasChild = false;
let nextJsonUrl = '';
let isLoading = false;
let getPreviewContents: () => void;
let previewPageNum = 1;
let previewPage = 1;

/**
 * 获取无子栏目专题的更多稿件
 */
const getMoreTopicJson = () => {
  fetchGroupJson(nextJsonUrl).then((res) => {
    hasNext = res.hasNext;
    nextJsonUrl = res.nextJsonUrl;
    if (res.dataList && res.dataList.length) {
      addNewsToList(res.dataList, $('#topic-news-list'));
    }
    isLoading = false;
    const loadingDom = $('#topic-news-list').find('.topic-content-loading');
    if (loadingDom && loadingDom.length) {
      loadingDom.remove();
    }
    if (!hasNext) {
      $('body').off('scroll');
      $('#topic-news-list').append(
        '<div class="topic-content-finish">已加载全部内容</div>',
      );
    }
  });
};

const addTopicLoadingIcon = (
  node1: JQuery<HTMLElement>,
  node2: JQuery<HTMLElement>,
  scrollTop: number,
) => {
  node1.append(
    `<div class="topic-content-loading"><img src="${contentLoadingImg}" class="topic-content-loading-img" alt="正在加载..."></div>`,
  );
  node2.scrollTop(scrollTop + 40);
};

let titleSwiperVisible = false;
/**
 * 监听无子栏目专题内容的滚动页面
 */
const initTopicScroll = () => {
  $('body').on(
    'scroll',
    throttle((evt) => {
      if (isHasChild) {
        const emptyLineNode = document.getElementById('empty-line');
        if (emptyLineNode) {
          const titleSwiperRect = emptyLineNode.getBoundingClientRect();
          if (titleSwiperRect && titleSwiperRect.top <= 0) {
            if (!titleSwiperVisible) {
              titleSwiperVisible = true;
              $('#topic-group-title-swiper').show();
            }
          } else if (titleSwiperRect && titleSwiperRect.top > 0) {
            if (titleSwiperVisible) {
              titleSwiperVisible = false;
              $('#topic-group-title-swiper').hide();
            }
          }
        }
      }
      if (!isHasChild) {
        const { offsetHeight, scrollHeight, scrollTop } = evt.currentTarget;
        if (offsetHeight + scrollTop + 20 > scrollHeight) {
          if (!isLoading && hasNext) {
            addTopicLoadingIcon(
              $('#topic-news-list'),
              $(evt.currentTarget),
              scrollTop,
            );
            isLoading = true;
            if (staticType) {
              getMoreTopicJson();
            } else if (!staticType && getPreviewContents) {
              previewPage += 1;
              previewPageNum += 1;
              getPreviewContents();
            }
          }
        }
      }
    }, 250),
  );
};

type TopicChannel = {
  id: string;
  topicId: string;
  name: string;
  groupJson: string;
};
let groupTitleSwiper: Swiper;
let isChildBoxClick = false;
const topicChannel: { [propName: string]: TopicChannel } = {};
/**
 * 添加专题稿件和子节点
 * @param channels
 */
const addNewsAndChild = (channelList: RMT.TopicChannelList[]) => {
  channelList.forEach((channel, index) => {
    const titleNode = `<div class="topic-child-title-text">${channel.name}</div>`;
    const moreNode = `<div class="topic-child-more">更多<img class="topic-child-more-logo" src="${topicMoreRightImg}" alt="更多"></div>`;
    const childTitleNode = `<div data-id="${channel.id}" class="topic-child-title">${titleNode}${moreNode}</div>`;
    const childListNode = `<div class="topic-child-news-list"></div>`;
    const childBox = `<div id="topic-child-box-${
      index + 1
    }" class="topic-child-box">${childTitleNode}${childListNode}</div>`;
    $('#topic-child-list').append(childBox);
    addNewsToList(
      channel.contentList,
      $(`#topic-child-box-${index + 1}`).find('.topic-child-news-list'),
    );
  });
  const intersectionObserver = new IntersectionObserver(
    (entries) => {
      if (isChildBoxClick) {
        return;
      }
      entries.forEach((item) => {
        if (item.intersectionRatio >= 1) {
          const id = $(item.target).attr('data-id');
          const index = channelList.findIndex((temp) => temp.id === id);
          if (groupTitleSwiper && index !== -1) {
            groupTitleSwiper.slideTo(index);
            $('.active-group-line').removeClass('active-group-line');
            $($('.group-slide')[index])
              .find('.group-line')
              .addClass('active-group-line');
          }
        }
      });
    },
    {
      root: document.querySelector('body'),
      threshold: 1,
    },
  );
  const list = document.querySelectorAll('.topic-child-title');
  list.forEach((el) => {
    intersectionObserver.observe(el);
  });
};

let nextGroupJsonUrl = '';
const getGroupJson = () => {
  if (!hasNext || !nextGroupJsonUrl) {
    return;
  }
  fetchGroupJson(nextGroupJsonUrl).then((res) => {
    hasNext = res.hasNext;
    nextGroupJsonUrl = res.nextJsonUrl;
    addNewsToList(res.dataList, $('#topic-group-list'));
    isLoading = false;
    const loadingDom = $('#topic-group-list').find('.topic-content-loading');
    if (loadingDom && loadingDom.length) {
      loadingDom.remove();
    }
    if (!hasNext) {
      $('#topic-group-content').off('scroll');
      $('#topic-group-list').append(
        '<div class="topic-content-finish">已加载全部内容</div>',
      );
    }
  });
};

let previewGroupPages = 1;
let previewGroupPageNum = 1;
let previewGruopId = '';
const getPreviewGroupContents = () => {
  fetchTopicChannelContent(
    previewGruopId,
    siteId,
    previewGroupPageNum,
    20,
    previewGroupPages,
  ).then((res) => {
    if (Number(res.status) === 200) {
      hasNext = previewGroupPages < res.pages;
      addNewsToList(res.list, $('#topic-group-list'));
      isLoading = false;
      const loadingDom = $('#topic-group-list').find('.topic-content-loading');
      if (loadingDom && loadingDom.length) {
        loadingDom.remove();
      }
      if (!hasNext) {
        $('#topic-group-content').off('scroll');
        $('#topic-group-list').append(
          '<div class="topic-content-finish">已加载全部内容</div>',
        );
      }
    }
  });
};

/**
 * 处理滚轮滚动事件
 * @param evt
 */
const wheelHandler = (evt: Event) => {
  if ((evt.target as HTMLElement).tagName === 'BODY') {
    evt.preventDefault();
  }
};

const toCloseGroupContent = () => {
  document.body.removeEventListener('wheel', wheelHandler);
  $('#topic-group-content').off('scroll');
  $('#topic-group-content')
    .removeClass('topic-group-content-zoom-in')
    .addClass('topic-group-content-zoom-out');
  setTimeout(() => {
    $('#topic-group-list').empty();
    $('#topic-group-content').scrollTop(0);
    $('#topic-group-content').hide();
  }, 450);
};

const initChannelBoxMoreClick = () => {
  $('.topic-child-title').on('click', (evt) => {
    const { id } = evt.currentTarget.dataset;
    if (id) {
      const channel = topicChannel[id];
      if (channel) {
        nextGroupJsonUrl = channel.groupJson;
        hasNext = !!nextGroupJsonUrl;
        if (staticType) {
          window.history.pushState({}, '', window.location.href);
        }
        $('#topic-group-list').empty();
        $('#topic-group-content').show();
        $('#topic-group-content')
          .removeClass('topic-group-content-zoom-out')
          .addClass('topic-group-content-zoom-in');
        isLoading = true;
        if (staticType) {
          getGroupJson();
        } else {
          previewGruopId = id;
          getPreviewGroupContents();
        }
        document.body.addEventListener('wheel', wheelHandler, {
          passive: false,
        });
        $('#topic-group-content').on(
          'scroll',
          throttle((scrollEvt) => {
            const { offsetHeight, scrollHeight, scrollTop } =
              scrollEvt.currentTarget;
            if (offsetHeight + scrollTop + 20 > scrollHeight) {
              if (!isLoading && hasNext) {
                addTopicLoadingIcon(
                  $('#topic-group-list'),
                  $(scrollEvt.currentTarget),
                  scrollTop,
                );
                isLoading = true;
                if (staticType) {
                  getGroupJson();
                } else {
                  previewGroupPageNum += 1;
                  previewGroupPages += 1;
                  getPreviewGroupContents();
                }
              }
            }
          }, 250),
        );
        window.addEventListener(
          'popstate',
          () => {
            toCloseGroupContent();
          },
          {
            capture: false,
            once: true,
          },
        );
      }
    }
  });
};

const initCarousel = (list: RMT.TopicCarouselNews[]) => {
  const html = list.map((item) => {
    const imgNode = `<img class="topic-news-img" alt="${item.data.title}" onerror="this.src='${process.env.DEFAULT_IMAGE_16_9}'" src="${item.carouselImgUrl}">`;
    const titleNode = `<div class="topic-news-title">${item.data.title}</div>`;
    const newsNode = `<div class="topic-news-box">${imgNode}${titleNode}</div>`;
    const aNode = `<a class="topic-news-link swiper-slide" href="${item.data.url}" target="_blank">${newsNode}</a>`;
    return aNode;
  });
  $('#topic-swiper').find('.swiper-wrapper').append(html.join(''));
  $('#topic-swiper').show();
  // eslint-disable-next-line no-new
  new Swiper('#topic-swiper', {
    autoplay: {
      delay: 5000,
    },
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
};

const initTopicChannelHTML = (channelList: RMT.TopicChannelList[]) => {
  $('body').on('click', (evt) => {
    if (
      evt.target.tagName === 'BODY' &&
      $('#topic-group-content').css('display') !== 'none'
    ) {
      if (staticType) {
        window.history.back();
      } else {
        toCloseGroupContent();
      }
    }
  });
  const html: string[] = [];
  channelList.forEach((item, index) => {
    topicChannel[item.id] = {
      id: item.id,
      topicId: item.topicid,
      name: item.name,
      groupJson: item.groupJsonUrl,
    };
    const nameHtml = `<div class="group-name">${item.name}</div>`;
    const lineHtml = `<div class="group-line ${
      index === 0 ? 'active-group-line' : ''
    }"></div>`;
    const slideHtml = `<div class="swiper-slide group-slide">${nameHtml}${lineHtml}</div>`;
    html.push(slideHtml);
  });
  $('#topic-group-title-swiper').find('.swiper-wrapper').append(html.join(''));
  groupTitleSwiper = new Swiper('#topic-group-title-swiper', {
    slidesPerView: 'auto',
    freeMode: true,
    centerInsufficientSlides: true,
    breakpoints: {
      320: {
        spaceBetween: 15,
      },
      650: {
        spaceBetween: 20,
      },
    },
    on: {
      click: (swiper) => {
        const { clickedIndex } = swiper;
        $('.active-group-line').removeClass('active-group-line');
        $($('.group-slide')[clickedIndex])
          .find('.group-line')
          .addClass('active-group-line');
        const childBoxNode = document.getElementById(
          `topic-child-box-${clickedIndex + 1}`,
        );
        if (childBoxNode) {
          const { offsetTop } = childBoxNode;
          isChildBoxClick = true;
          if (version.weixin && version.android) {
            childBoxNode.scrollIntoView({
              behavior: 'smooth',
            });
          } else {
            document.body.scroll({
              top:
                offsetTop -
                (version.mobile ? 40 + $('.guide-image')[0].offsetHeight : 40),
              behavior: 'smooth',
            });
          }
          setTimeout(() => {
            isChildBoxClick = false;
          }, 1000);
        }
      },
    },
  });
  initChannelBoxMoreClick();
};

/**
 * 获取专题信息
 */
const initTopicJson = () => {
  const topicJsonUrl = getSingleValueFromInput('topicJson');
  if (topicJsonUrl) {
    fetchTopicJson(topicJsonUrl).then((res) => {
      ({ isHasChild } = res);
      if (res.hasNext) {
        hasNext = res.hasNext;
      }
      if (res.nextJsonUrl) {
        nextJsonUrl = res.nextJsonUrl;
      }
      if (!isHasChild && res.dataList && res.dataList.length) {
        addNewsToList(res.dataList, $('#topic-news-list'));
      } else if (isHasChild && res.channelList && res.channelList.length) {
        addNewsAndChild(res.channelList);
        initTopicChannelHTML(res.channelList);
      }
      if (res.carouselList && res.carouselList.length) {
        initCarousel(res.carouselList);
      }
      initTopicScroll();
    });
  }
};

/**
 * 获取没有子栏目的稿件列表
 */
getPreviewContents = () => {
  fetchTopicContent(topicId, siteId, previewPageNum, 20, previewPage).then(
    (res) => {
      if (Number(res.status) === 200) {
        addNewsToList(res.list, $('#topic-news-list'));
        isLoading = false;
        const loadingDom = $('#topic-news-list').find('.topic-content-loading');
        if (loadingDom && loadingDom.length) {
          loadingDom.remove();
        }
        hasNext = previewPage < res.pages;
        if (!hasNext) {
          $('body').off('scroll');
          $('#topic-news-list').append(
            '<div class="topic-content-finish">已加载全部内容</div>',
          );
        }
      }
    },
  );
};

/**
 * 获取子栏目
 * @param topicId
 */
const getPreviewTopicChannel = () => {
  fetchTopicChannel(topicId).then((res) => {
    if (Number(res.status) === 200) {
      addNewsAndChild(res.channelList);
      initTopicChannelHTML(res.channelList);
    }
  });
};

/**
 * 获取专题信息
 * @param newsId
 * @param appId
 * @param contentType
 */
const getPreviewContentDetail = (appId: string, contentType: number) => {
  fetchContentDetail(topicId, appId, contentType).then((res) => {
    if (Number(res.status) === 200) {
      if (res.carouselList && res.carouselList.length) {
        initCarousel(res.carouselList);
      }
      isHasChild = !!res.ischild;
      if (res.ischild) {
        getPreviewTopicChannel();
        $('.topic-group-back').on('click', () => {
          toCloseGroupContent();
        });
      } else if (!res.ischild && getPreviewContents) {
        getPreviewContents();
      }
      initTopicScroll();
    }
  });
};

(() => {
  const contentType = getSingleValueFromInput('contentType');
  if (!Number(staticType)) {
    const query = getUrlQuery();
    if (!Number(query.isMobile)) {
      const previewSubtitle = $('.preview-subtitle');
      if (previewSubtitle) {
        previewSubtitle.show();
      }
      const previewKeyword = $('.preview-keyword');
      if (previewKeyword) {
        previewKeyword.show();
      }
      const previewDescription = $('.preview-description');
      if (previewDescription) {
        previewDescription.show();
      }
    }
  }
  if (Number(staticType)) {
    initSiteJson();
    getBrowerAppId(() => {
      addReadCount();
    });
    initTopicJson();
    YouMeng.initYoumeng();
    YouMeng.initYoumengLog(() => {
      YouMeng.pushRecord(
        { article_id: topicId },
        'gzcmc.xhc.h5.manuscript.view.click',
        'onload',
      );
    });

    NanFang.init().then(() => {
      NanFang.openArticle(topicId);
    });
    initWxSdk({
      wxShare: {
        title: getSingleValueFromInput('shareTitle') || document.title,
        desc: getSingleValueFromInput('shareDesc') || '',
        imgUrl: (getSingleValueFromInput('shareImgUrl') ||
          process.env.DEFAULT_SHARE_IMAGE) as string,
      },
    });
  } else if (!Number(staticType) && topicId && contentType) {
    getBrowerAppId((browerId) => {
      getPreviewContentDetail(browerId, Number(contentType));
    });
  }
  initDescriptionExpendClose();
})();
